import React from 'react';
import { motion } from 'framer-motion';
import AZ from '../../assets/logos/az.png';
import YouTubeModalButton from '../Sections/YouTubeModalButton';

// Palette white / gold
const colors = {
  text: '#3B2F2A',
  textSoft: '#5C4A3D',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  glassBg: 'rgba(255, 255, 255, 0.7)',
  glassBorder: 'rgba(198, 156, 109, 0.25)',
  shadow: '0 8px 24px rgba(107, 90, 70, 0.06)',
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const MainContainerAZLG = () => {
  return (
    <>
      <style>{`
        .azlg-section {
          position: relative;
          padding: 100px 0;
          background: linear-gradient(135deg, #EAD5C0 0%, #D4B895 30%, #C69C6D 60%, #E8CFB5 100%);
          background-size: 400% 400%;
          animation: goldGradient 15s ease infinite;
          overflow: hidden;
          text-align: center;
        }

        @keyframes goldGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        /* Orbes floues */
        .azlg-section::before,
        .azlg-section::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.3;
          z-index: 0;
          pointer-events: none;
        }

        .azlg-section::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .azlg-section::after {
          width: 40vw;
          height: 40vw;
          background: #E8CFB5;
          bottom: -10%;
          right: -5%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .container {
          position: relative;
          z-index: 2;
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 20px;
        }

        /* Logo */
        .logo-float {
          display: inline-block;
          width: 220px;
          filter: drop-shadow(0 8px 16px rgba(0,0,0,0.1));
          margin-bottom: 30px;
        }

        /* Carte texte glass */
        .text-card {
          background: ${colors.glassBg};
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid ${colors.glassBorder};
          border-radius: 32px;
          padding: 40px 30px;
          box-shadow: ${colors.shadow};
          transition: box-shadow 0.3s;
        }

        .text-card:hover {
          box-shadow: 0 16px 32px rgba(184, 138, 86, 0.15);
        }

        .main-title {
          font-size: clamp(2rem, 5vw, 2.8rem);
          font-weight: 700;
          color: ${colors.text};
          margin-bottom: 20px;
          letter-spacing: -0.5px;
          position: relative;
        }

        .main-title::after {
          content: '';
          display: block;
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.gold}, ${colors.goldDark});
          margin: 15px auto 0;
          border-radius: 2px;
        }

        .description {
          font-size: 1.1rem;
          color: ${colors.textSoft};
          line-height: 1.7;
          margin-bottom: 30px;
        }

        .video-wrapper {
          display: flex;
          justify-content: center;
        }

        @media (max-width: 768px) {
          .azlg-section {
            padding: 70px 0;
          }
          .text-card {
            padding: 30px 20px;
          }
        }
      `}</style>

      <section className="azlg-section">
        <div className="container">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
          >
            {/* Logo */}
            <motion.div variants={itemVariants}>
              <motion.img
                src={AZ}
                alt="Azyekos Logo"
                className="logo-float"
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
              />
            </motion.div>

            {/* Bloc texte */}
            <motion.div className="text-card" variants={itemVariants}>
              <h1 className="main-title">AZYEKOS LOUNGES</h1>
              <p className="description">
                Azyekos Lounges est un salon privé exclusif situé au cœur de l'aéroport International de Nd'jili à Kinshasa dans la zone Nationale.<br />
                Offrant un cadre élégant et raffiné, nous proposons un service de restauration haut de gamme, alliant saveurs locales et internationales,
                pour satisfaire les palais les plus exigeants.
              </p>
              <motion.div className="video-wrapper" variants={itemVariants}>
                <YouTubeModalButton videoId="ByUdf3fodho" />
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default MainContainerAZLG;